/** Game constants: time across the clocks (64.4). Part of src/constants.ts (re-exported there; import from '../constants'). */

// =============================================================================
// TIME — converting between the clocks
// =============================================================================

/**
 * Decision 110: one ruleset constant converts classic's turn-counted rules (status effects, objective timers,
 * knowledge ages) when they run on the continuous clock. A starting value (the low end of the measured median plan
 * round, 15–20 s at 3v3), tuned in play; fixed, never set per machine. It converts once, at the rule.
 */
export const SECONDS_PER_TURN = 15;
